import BaseService from "./BaseService";

class AudienceService {
  static async list(data) {
    const params = (data && BaseService.cleanQueryParams(data)) || {};
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(`/audiences?${queryParams}`);
  }

  static async create(data) {
    return await BaseService.callAPI(`/audiences`, "POST", data);
  }

  static async details({ id }) {
    return await BaseService.callAPI(`/audiences/${id}`);
  }

  static async update({ id, data }) {
    return await BaseService.callAPI(`/audiences/${id}`, "POST", data);
  }

  static async delete({ id }) {
    return await BaseService.callAPI(`/audiences/${id}`, "DELETE");
  }

  static async deleteAssignment({ id }) {
    return await BaseService.callAPI(`/audiences/assignment/${id}`, "DELETE");
  }

  static async users({ id, data }) {
    const params = (data && BaseService.cleanQueryParams(data)) || {};
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(`/audiences/${id}/users?${queryParams}`);
  }

  static async export({ fileType, data, id }) {
    const params = BaseService.cleanQueryParams(data);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(
      `/audiences/${id}/users/export/${fileType}?${queryParams}`,
      "POST",
      null,
      { responseType: "blob" }
    );
  }

  static async assignments({ id }) {
    return await BaseService.callAPI(`/audiences/${id}/assignments`);
  }

  static async addAssignment({ id, data }) {
    return await BaseService.callAPI(
      `/audiences/${id}/assignments`,
      "POST",
      data
    );
  }
}

export default AudienceService;
